module.exports = __webpack_public_path__ + "static/media/background.19e1a554.png";